import { render } from "./sectors-selector.vue?vue&type=template&id=03dcb289&scoped=true&ts=true"
import script from "./sectors-selector.vue?vue&type=script&lang=ts"
export * from "./sectors-selector.vue?vue&type=script&lang=ts"

import "./sectors-selector.vue?vue&type=style&index=0&id=03dcb289&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dcb289"]])

export default __exports__